module.exports = __webpack_public_path__ + "static/media/YF96_3.1a38c342.jpg";